import React, { useCallback, useEffect, useState } from 'react'
import { MarkingChatStyles } from './Style'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import qc from 'keys/queryClient'
import { Avatar, Chip, IconButton, TextareaAutosize } from '@mui/material'
import { thirdly } from 'styles/theme'
import { Textarea } from 'components/Form'
import { Close, Send } from '@mui/icons-material'
import { actions } from 'store'
import { markingWordsHooks } from '.'
import { formatDateTime } from 'utils/formatter'
import { secretStorage } from 'config'
import { createLabelerResponseFetch, getLabelerQuestionFetch, updateResponseIsReadFetch } from 'store/middlewares/labelerQuestion.crud'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'

const MarkingChat = (props) => {
    const { word, onClose, disabled } = props
    const [message, setMessage] = useState("")
    const queryClient = useQueryClient()
    const isSuperuser = secretStorage.getItem("user")?.is_superuser
    const { save: saveWords, loading: saveLoading } = markingWordsHooks.useSave()
    const { assessment } = useSelector(state => state.assessment)
    const dispatch = useDispatch()

    // const sendResponse = markingWordsHooks.

    const { mutateAsync: updateResponseIsRead } = useMutation({
        mutationFn: updateResponseIsReadFetch
    })

    const { mutateAsync: createLabelerQuestion } = useMutation({
        mutationFn: createLabelerResponseFetch,
        onSuccess: () => {
            setMessage('')
            queryClient.invalidateQueries({ queryKey: [qc.markingMessages, word?.id] })
        }
    })

    const labelerQuestion = useQuery({
        queryKey: [qc.markingMessages, word?.id],
        queryFn: async () => {
            let params = { word: word?.id }
            const { data } = await getLabelerQuestionFetch(params)

            if (data.length)
                if (data.length == 1)
                    return data[0]
                else return data
            else return {}
        }
    })

    const sendResponse = useCallback(async () => {
        const newWord = await createLabelerQuestion({
            question: labelerQuestion.data?.id,
            text: message,
            word: word?.id,
            assessment: assessment.id,
            word_def: word?.word_def_id,
        })
        // dispatch(actions.updateSingleWord({ index: word?.index, word: { ...word, id: newWord } }))
        // if (!word?.id)
        //     queryClient.invalidateQueries({ queryKey: [qc.assessmentAndWords] })

    }, [labelerQuestion, assessment, word])

    useEffect(() => {
        if (labelerQuestion.data?.id) {
            updateResponseIsRead(labelerQuestion.data?.id)
            // queryClient.invalidateQueries({ queryKey: [qc.assessmentAndWords] })
        }
    }, [labelerQuestion.data?.id])

    return (
        <MarkingChatStyles className={disabled && !isSuperuser && 'disabled2'}>
            <div className='chat-title'>
                {word.word_def_text}
                <IconButton onClick={onClose}>
                    <Close />
                </IconButton>
            </div>
            <div className='chat-responses'>
                {labelerQuestion.data?.labeler_responses?.map((message, index) =>
                    <div className='wrap-chat-message' key={index}>
                        <div className='created-by'>
                            {message.is_superuser ?
                                <Avatar sx={{ bgcolor: thirdly }} /> :
                                <Avatar />
                            }
                            <div className='sender-details'>
                                <div>
                                    {message.created_by}
                                </div>
                                <div>
                                    {formatDateTime(message.update_date)}
                                </div>
                            </div>
                        </div>
                        <div className='chat-message'>{message.text}</div>
                    </div>
                )}
            </div>
            <div className='chat-footer'>
                <div className='write-message'>
                    <Textarea
                        aria-label="minimum height"
                        minRows={1}
                        bg
                        textAlign={"right"}
                        // maxRows={4}
                        fontSize={15}
                        input={{
                            value: message,
                            onChange: (val, e) => {
                                e.stopPropagation()
                                e.preventDefault()

                                setMessage(val)
                            }
                        }
                        }
                        placeholder={"מה השאלה?"}
                    />
                </div>
                <div className='send-button'>
                    <IconButton onClick={sendResponse}>
                        <Send />
                    </IconButton>
                </div>
            </div>
        </MarkingChatStyles>
    )
}

export default MarkingChat